module.exports = __webpack_public_path__ + "static/media/ic-export-black.9cd5452c.svg";